import * as React from 'react';
import {Icon, PriorityIcon, Flex, Input} from '@priority-software/priority-style-react';
import {Operator} from '../../consts/operators';
import {getDecimalSign, getThousandSign} from '../../../../_shared/GWTBridge/invoke/priTextBox';
import {observer} from 'mobx-react';
import {Label} from '../../../../components/Common/Label';

@observer
export class RangeControl extends React.Component<any, any> {
    onMinValueChange = number => {
        this.props.onChange({
            min: number,
            max: this.getMaxValue()
        });
    };

    onMaxValueChange = number => {
        this.props.onChange({
            min: this.getMinValue(),
            max: number
        });
    };

    getMinValue() {
        return this.props.value ? this.props.value.min : '';
    }

    getMaxValue() {
        return this.props.value ? this.props.value.max : '';
    }

    renderInput = props => {
        return (
            <Input
                direction="ltr"
                value={props.formated || props.value}
                autoFocus={props.autoFocus}
                onFocus={this.props.setActive}
                onBlur={this.props.unsetActive}
                disabled={this.props.isDisabled}
                placeholder={props.placeholder}
                componentClasses="filter-input"
                onChange={event => props.handleChange(event.target.value)}
                onKeyUp={event => props.handleKeyUp?.(event)}
            >
                {props.value && (
                    <Icon
                        icon={PriorityIcon.closeSmall}
                        skin="standart"
                        onClick={e => {
                            e.stopPropagation();
                            props.handleChange('');
                        }}
                    />
                )}
            </Input>
        );
    };

    render() {
        const {
            operator,
            validationControl: ValidationControl,
            fromLabel,
            toLabel,
            autoFocus
        } = this.props;
        const between = operator === Operator.Between;

        return (
            <Flex componentClasses="control-wrapper">
                {between && (
                    <Label textColor="secondary-400" skin="paragraph-2">
                        {fromLabel}
                    </Label>
                )}
                <ValidationControl
                    render={this.renderInput}
                    {...this.props}
                    autoFocus={autoFocus}
                    value={this.getMinValue()}
                    onChange={this.onMinValueChange}
                    decimalSign={getDecimalSign()}
                    thousandSign={getThousandSign()}
                />
                {between && (
                    <React.Fragment>
                        <Label skin="paragraph-2" textColor="secondary-400">
                            {toLabel}
                        </Label>
                        <ValidationControl
                            render={this.renderInput}
                            {...this.props}
                            autoFocus={false}
                            value={this.getMaxValue()}
                            onChange={this.onMaxValueChange}
                            decimalSign={getDecimalSign()}
                            thousandSign={getThousandSign()}
                        />
                    </React.Fragment>
                )}
            </Flex>
        );
    }
}
